
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'rov'
    })
  } // computed
}; // export default
